import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_94: FaireProductEntity = {
  token: "catalog_prod_prod-94",
  type: "product",
  name: "Wall Decor",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=400&h=400&fit=crop",
  priceDollars: 10.93,
  msrpDollars: 27.33,
  sku: "CA0094",
  caseSize: 2,
  material: "Glass",
  collectionToken: "col_camp",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 35,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
